module.exports = __webpack_public_path__ + "static/media/Folks-Heavy.58133875.ttf";